import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number, currency = 'USD'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount);
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(date));
}

export function formatDateTime(date: string | Date): string {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(date));
}

export function getClientPOSUrl(slug: string): string {
  const baseDomain = import.meta.env.VITE_POS_BASE_DOMAIN || 'blazepos.app';
  return `https://${slug}.${baseDomain}`;
}

export function calculateMRR(
  plan: { base_price: number; per_location_price: number; per_register_price: number; included_locations: number; included_registers: number },
  subscription: { licensed_locations: number; licensed_registers: number }
): number {
  const extraLocations = Math.max(0, subscription.licensed_locations - plan.included_locations);
  const extraRegisters = Math.max(0, subscription.licensed_registers - plan.included_registers);
  
  return plan.base_price + (extraLocations * plan.per_location_price) + (extraRegisters * plan.per_register_price);
}


